import { transformFiltersForBackend } from '@/utils/filterUtils';

export function buildQueryString(params: Record<string, any>): string {
    const searchParams = new URLSearchParams();

    for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === null || value === '') {
            continue;
        }

        // Speciální handling pro filters - transformuj na backendový formát
        if (key === 'filters' && Array.isArray(value)) {
            if (value.length > 0) {
                const backendFilters = transformFiltersForBackend(value);
                searchParams.append(key, JSON.stringify(backendFilters));
            }
            continue;
        }

        if (Array.isArray(value)) {
            if (value.length > 0) {
                for (const item of value) {
                    searchParams.append(`${key}[]`, String(item));
                }
            }
            continue;
        }

        if (typeof value === 'object') {
            searchParams.append(key, JSON.stringify(value));
            continue;
        }

        searchParams.append(key, String(value));
    }

    return searchParams.toString();
}
